import { servicePendingTasks as services } from 'services';
import { TAsyncStatesHandlers } from 'hooks/use-mutation-hook-wrapper';
import { pendingTasks as types, network } from 'types';
import useQueryHookWrapper from 'hooks/use-query-hook-wrapper';

const useGetPendingTasks = (
    arg0?: TAsyncStatesHandlers<
        network.TQueryDefWrapper<types.TPendingTasks[]>,
        string
    >,
) => {
    return useQueryHookWrapper<
        network.TQueryDefWrapper<types.TPendingTasks[]>,
        string,
        null
    >({
        queryKey: 'pending-tasks',
        queryFn: services.get,
        queryConfig: arg0,
        values: null,
    });
};

export default useGetPendingTasks;
